// @flow
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import queryString from 'query-string';

import style from './CheckoutAsyncCommon.scss';
import yogiLeg from '../../../../../assets/img/YOGI-QEMPO2.png';
import routes from "../../../../../routes";

type Props = {
  +goToRedirect: (route: string) => void;
};

export default class CheckoutAsyncSuccess extends Component<Props> {
  componentDidMount() {
    const parsedQuery = queryString.parse(location.search);
    const orderId = window.location.pathname.split("/")[4];
    let url = routes.NEW_ORDER.children.CHECKOUT_SUCCESS.routePath.replace(':orderId', orderId);
    if (!!parsedQuery && !!parsedQuery.is_diy && parsedQuery.is_diy === 'true') {
      url = routes.PURCHASE.routePath.replace(':id', orderId);
    }
    this.props.goToRedirect(url);   
  }

  render() {
    return (
      <section className={style.safetyPayResponse}>
        <img src={yogiLeg} alt="Qempo"/>
        <FormattedMessage id="newOrder.checkoutAsyncSuccess.title">{
          text => <h2>{text}</h2>
        }</FormattedMessage>
        <FormattedMessage id="newOrder.checkoutAsyncSuccess.subtitle">{
          text => <p>{text}</p>
        }</FormattedMessage>
      </section>);
  }
}



// WEBPACK FOOTER //
// ./src/modules/new-order/CheckoutStep/components/CheckoutAsyncResponse/CheckoutAsyncSuccess.jsx